// TotalPe – Central mock data store
// Edit this file to update all content across the app.
// Swap any value with a real API call / CMS fetch as you scale.

export const BRAND = {
  name:         'TotalPe',
  tagline:      "India's Smart POS Platform",
  description:  'Complete billing, KOT, payments and inventory for restaurants, hotels and cafes. Works offline. Free to start.',
  email:        'support@totalpe.io',
  phone:        '+91 8888335958',
  address:      'ABNScripts Technologies Pvt. Ltd., SR NO.18, ROYAL 18, FLAT NO.201, Pimpri Colony, Pimpri-Chinchwad, Maharashtra 411018',
  cin:          '',
  appStoreUrl:  'https://apps.apple.com/in/app/totalpe',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.totalpe.android',
  socials: {
    twitter:   'https://twitter.com/totalpe_in',
    instagram: 'https://instagram.com/totalpe.in',
    linkedin:  'https://linkedin.com/company/totalpe',
    youtube:   'https://youtube.com/@totalpe',
  },
};

export const NAV_LINKS = [
  { label: 'Home',      path: '/'          },
  //{ label: 'Services',  path: '/services'  },
  { label: 'About Us',  path: '/about'     },
  { label: 'Terms',     path: '/terms'     },
  { label: 'Privacy',   path: '/privacy'   },
];

export const HERO = {
  //eyebrow:     'Trusted by 50,000+ merchants across India',
  title:       'Run your hotel smarter,',
  titleAccent: 'generate bills faster.',
  subtitle:    'Complete POS billing for restaurants, hotels and cafes. Works offline too.',
};

export const STATS = [
  /*{ value: '50K+',    label: 'Active Merchants'   },
  { value: '4.8★',    label: 'App Store Rating'   },
  { value: '₹200Cr+', label: 'Payments Processed' },
  { value: '200+',    label: 'Cities Covered'     },*/
];

export const FEATURES = [
  { icon: '🧾', title: 'Smart POS Billing',    desc: 'Generate GST-compliant bills instantly. Print or WhatsApp receipts to customers.'          },
  { icon: '📋', title: 'KOT Management',       desc: 'Kitchen order tickets auto-printed. Reduce errors and speed up service by 40%.'              },
  /*{ icon: '💳', title: 'All Payment Modes',    desc: 'UPI, cards, cash, wallets — accept everything. Zero extra hardware required.'                },
  { icon: '📊', title: 'GST Reports',          desc: 'Daily, weekly, monthly reports. GSTR-1 ready CSV/PDF export in one click.'                  },
  { icon: '📦', title: 'Inventory Tracking',   desc: 'Track stock levels, get low-stock alerts, and reduce food wastage by 20%.'                  },
  { icon: '🏪', title: 'Multi-Outlet Support', desc: 'Manage multiple branches from one login. Centralised sales and inventory reports.'           },  
  { icon: '🔔', title: 'Customer Loyalty',     desc: 'Built-in loyalty points, birthday offers and WhatsApp marketing campaign tools.'            },*/
  { icon: '📶', title: 'Offline Mode',         desc: 'Bills sync when internet returns. Never lose a sale due to poor connectivity.'              },
  { icon: '🏪', title: 'Multi-Outlet Support', desc: 'Manage multiple branches from one login. Centralised sales and inventory reports.'           },
];

export const STORE_TYPES = [
  { icon: '🍛', label: 'Restaurant'    },
  { icon: '🏨', label: 'Hotel'         },
  { icon: '☕', label: 'Cafe'          },
  { icon: '🧁', label: 'Bakery'        },
  { icon: '🍕', label: 'Cloud Kitchen' },
  { icon: '🥤', label: 'Juice Bar'     },
  { icon: '🫕', label: 'Dhaba'         },
  { icon: '🍦', label: 'Ice Cream'     },
];

export const HOW_IT_WORKS = [
  { step: 1, title: 'Download the app',      desc: 'Available on iOS App Store and Google Play Store. Free to install.'  },
  { step: 2, title: 'Register your outlet',  desc: 'Add business details, GST number and menu items in minutes.'          },
  { step: 3, title: 'Start billing',         desc: 'Take orders, print bills, accept payments — all from one screen.'     },
  //{ step: 4, title: 'Grow with insights',    desc: 'Use daily reports, inventory alerts and loyalty tools to scale.'      },
];

export const TESTIMONIALS = [
  { text: 'TotalPe transformed how we run our 3 restaurants. The KOT system alone saved us 2 hours per day. Billing errors dropped to zero.',       name: 'Priya Deshmukh', role: 'Owner, Spice Garden Restaurants, Pune',  avatar: 'PD', stars: 5 },
  { text: 'Offline billing was a game changer. Our area has poor internet. TotalPe just works even without internet. Best Billing software.',       name: 'Ramesh Thorat',  role: 'Owner, Hotel Shivam, Nashik',            avatar: 'RT', stars: 5 },
  { text: 'GST reports used to take my accountant 2 days each month. Now it takes 10 minutes with TotalPe. Worth every rupee.',                    name: 'Anita Kulkarni', role: 'Manager, Cafe Aroma, Mumbai',            avatar: 'AK', stars: 5 },
  { text: 'We manage 5 outlets from one phone. Centralised sales report, inventory alerts everything at our fingertips. Highly recommended.',    name: 'Mohammed Rafiq', role: 'Director, Rafiq Hospitality Group, Pune', avatar: 'MR', stars: 5 },
];

export const PRICING_PLANS = [
  {
    name: 'Starter', price: '0', period: '/ month',
    desc: 'Perfect for single-outlet businesses just getting started.',
    features: [
      { text: '1 Outlet',             ok: true  },
      { text: 'Unlimited Bills',       ok: true  },
      { text: 'UPI & Cash Payments',   ok: true  },
      { text: 'Basic Sales Reports',   ok: true  },
      { text: 'KOT Printing',          ok: false },
      { text: 'Inventory Tracking',    ok: false },
      { text: 'GST Export',            ok: false },
      { text: 'Multi-outlet',          ok: false },
    ],
    cta: 'Get Started Free', featured: false,
  },
  {
    name: 'Professional', price: '999', period: '/ month',
    desc: 'The complete toolkit for growing restaurants and hotels.',
    features: [
      { text: 'Up to 3 Outlets',        ok: true  },
      { text: 'Unlimited Bills',         ok: true  },
      { text: 'All Payment Modes',       ok: true  },
      { text: 'Advanced Reports + GST',  ok: true  },
      { text: 'KOT Printing',            ok: true  },
      { text: 'Inventory Tracking',      ok: true  },
      { text: 'Customer Loyalty',        ok: true  },
      { text: 'Priority Support',        ok: false },
    ],
    cta: 'Start Free Trial', featured: true,
  },
  {
    name: 'Enterprise', price: '2,499', period: '/ month',
    desc: 'For hotel chains and multi-outlet restaurant groups.',
    features: [
      { text: 'Unlimited Outlets',           ok: true },
      { text: 'Unlimited Bills',             ok: true },
      { text: 'All Payment Modes',           ok: true },
      { text: 'Advanced Reports + GST',      ok: true },
      { text: 'KOT + Table Management',      ok: true },
      { text: 'Inventory + Wastage',         ok: true },
      { text: 'Loyalty + CRM',              ok: true },
      { text: 'Dedicated Account Manager',   ok: true },
    ],
    cta: 'Contact Sales', featured: false,
  },
];

export const TEAM = [
  { name: 'Aditya Bendre',  role: 'Co-Founder & CEO',          avatar: 'AB', bio: 'Serial entrepreneur with 10+ years in fintech and hospitality tech.' },
  { name: 'Neha Shirke',    role: 'Co-Founder & CTO',          avatar: 'NS', bio: 'Ex-Infosys engineer, passionate about building tools for Bharat.'     },
  { name: 'Kiran Pawar',    role: 'Head of Product',           avatar: 'KP', bio: 'Spent 5 years in restaurant operations before joining tech.'          },
  { name: 'Smita Jadhav',   role: 'Head of Customer Success',  avatar: 'SJ', bio: 'Obsessed with merchant happiness. Speaks 4 Indian languages.'         },
];

export const TIMELINE = [
  { year: '2021', event: 'Founded in Pimpri-Chinchwad. First 10 merchants onboarded.'         },
  { year: '2022', event: 'Launched on Play Store. 5,000 merchants. Rs.10Cr processed.'        },
  { year: '2023', event: 'iOS App Store launch. Expanded to 50+ cities. Series A funding.'    },
  { year: '2024', event: '50,000 merchants. Multi-outlet and enterprise tier launched.'       },
  { year: '2025', event: '200+ cities. Rs.200Cr+ processed. AI demand forecasting in beta.'   },
];

export const SERVICES_DETAIL = [
  {
    category: 'Billing & Payments', icon: '🧾',
    items: [
      { title: 'GST-Compliant Billing',    desc: 'Auto-calculate GST slabs, generate GSTIN-linked bills, WhatsApp PDF to customers.'   },
      { title: 'All Payment Acceptance',   desc: 'PhonePe, GPay, Paytm, credit/debit cards, net banking — one QR covers everything.'  },
      { title: 'Split Bill & Partial Pay', desc: 'Split bills by item or equally. Accept partial payments and track balances.'         },
      { title: 'Bill History & Reprint',   desc: 'Search any past bill by date, customer, or number. Reprint or re-share anytime.'    },
    ],
  },
  {
    category: 'Restaurant Operations', icon: '🍽️',
    items: [
      { title: 'Kitchen Order Tickets',    desc: 'Auto-send KOTs to kitchen printer when order is placed. Reduce verbal errors by 90%.' },
      { title: 'Table & Floor Management', desc: 'Visual floor plan, table status, merge tables, quick transfer between tables.'        },
      { title: 'Menu Builder',             desc: 'Add combos, variants, modifiers. Set availability windows and portion sizes.'         },
      { title: 'Captain / Waiter App',     desc: 'Staff take orders on their phone. Kitchen receives instantly. No paper pads.'         },
    ],
  },
  {
    category: 'Inventory & Stock', icon: '📦',
    items: [
      { title: 'Raw Material Tracking',  desc: 'Link ingredients to menu items. Stock auto-deducts with every sale.'               },
      { title: 'Low Stock Alerts',       desc: 'Get WhatsApp and app notifications before you run out of critical ingredients.'    },
      { title: 'Wastage Recording',      desc: 'Log daily wastage with reason codes. Reduce food cost by 15 to 20 percent.'       },
      { title: 'Supplier Management',    desc: 'Manage vendor contacts, purchase orders and payment history.'                     },
    ],
  },
  {
    category: 'Analytics & Compliance', icon: '📊',
    items: [
      { title: 'Daily Sales Dashboard',  desc: 'Revenue, footfall, average order value — all on one screen every morning.'       },
      { title: 'GST Reports & Export',   desc: 'GSTR-1 ready CSV/PDF. CA-friendly format. One-click send to email.'             },
      { title: 'Item-wise Performance',  desc: 'Know your bestsellers and slow movers. Tweak menu based on real data.'           },
      { title: 'Staff Performance',      desc: 'Track orders processed, cancellations and average service time per staff.'       },
    ],
  },
];

export const FAQ = [
  //{ q: 'Is TotalPe really free to use?',         a: 'Yes! The Starter plan is completely free with no hidden charges. Upgrade to Pro or Enterprise as you grow.'              },
  { q: 'Does it work without internet?',          a: 'Absolutely. TotalPe has a full offline mode. Bills are created locally and synced once connectivity returns.'            },
  { q: 'How do I get support?',                   a: 'We offer WhatsApp support, in-app chat and a phone line (Mon-Sat 10am-7pm). Enterprise users get a dedicated manager.'  },
  { q: 'Can I use TotalPe on multiple devices?',  a: 'Yes. Install on multiple phones and tablets. Data syncs in real time across all devices.'                               },
  { q: 'Is my billing data safe?',                a: 'Yes, all your data is securely stored.'         },
  { q: 'Do you support multiple languages?',      a: 'Currently TotalPe supports English. More regional languages coming soon.'                                      },
];